function Logo() {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={130}
            height={33}
            fill='none'>
            <path
                fill='#0357EE'
                d='m9.226 22.89-.8 1.868H0l2.097-4.918c.838-1.982 3.126-2.897 5.07-2.02.458.19.877.495 1.22.8a3.84 3.84 0 0 1 .839 4.27M18.644 24.758h-7.778l-.61-7.625c-.152-2.134 1.41-4.002 3.546-4.155.495-.038.991.038 1.449.152 1.486.458 2.592 1.754 2.706 3.393zM30.955 24.758h-8.35l-4.04-10.217a3.86 3.86 0 0 1 2.134-5.032c.458-.19.954-.267 1.45-.267a3.86 3.86 0 0 1 3.583 2.44z'
            />
            <path
                fill='#0357EE'
                fillRule='evenodd'
                d='M78.51 19.993c0-1.373.42-2.478 1.258-3.355.877-.915 1.982-1.335 3.393-1.335 1.296 0 2.287.42 3.05 1.22.762.801 1.105 1.83 1.105 3.127l-.076.915h-5.68c.114.533.343.915.724 1.22.381.266.839.419 1.372.419.343 0 .725-.076 1.106-.229.381-.152.724-.305.953-.495l.305-.23 1.22 2.021c-.114.115-.343.267-.648.496-.343.229-.61.343-.8.457a5.7 5.7 0 0 1-2.364.496c-1.525 0-2.707-.457-3.622-1.41-.839-.916-1.296-2.021-1.296-3.317m3.202-1.296h2.554a1.23 1.23 0 0 0-.305-.801c-.228-.229-.457-.343-.762-.343q-1.2 0-1.487 1.143'
                clipRule='evenodd'
            />
            <path
                fill='#0357EE'
                d='M66.846 24.72h-3.012v-9.035h1.64c.419 0 .724.076.914.267.229.19.343.419.343.724v.343h.038c.61-1.03 1.563-1.563 2.86-1.563 2.135 0 3.24 1.144 3.24 3.393v3.278c-.038.992 0 2.555 0 2.555h-1.754c-.457 0-.762-.115-.99-.305-.191-.229-.306-.534-.306-.991V19.42c0-.8-.343-1.182-.99-1.182-.878 0-1.488.42-1.793 1.296-.114.305-.19.724-.19 1.182z'
            />
            <path
                fill='#0357EE'
                fillRule='evenodd'
                d='M52.701 20.03c0-1.41.496-2.553 1.449-3.392.953-.877 2.173-1.335 3.622-1.335s2.668.458 3.621 1.335c.992.877 1.487 2.02 1.487 3.393s-.495 2.516-1.487 3.393c-.953.877-2.173 1.296-3.621 1.296-1.45 0-2.63-.42-3.622-1.296-.991-.877-1.449-2.02-1.449-3.393m3.012 0c0 .649.19 1.183.572 1.564s.877.61 1.487.61c.571 0 1.067-.19 1.448-.61.382-.42.61-.915.61-1.563s-.19-1.182-.61-1.601a1.9 1.9 0 0 0-1.448-.648c-.572 0-1.068.228-1.487.648q-.572.629-.572 1.6'
                clipRule='evenodd'
            />
            <path
                fill='#0357EE'
                d='m50.984 12.216.572 7.167.42 5.337h-2.173c-.915 0-1.297-.42-1.373-1.372l-.305-6.634h-.038c-.267.953-2.287 5.833-2.287 5.833H43.13s-2.02-4.918-2.173-5.452l-.114-.38h-.038c.076.838-.305 6.594-.305 6.594-.077.992-.458 1.373-1.373 1.373h-2.173l.496-6.29.572-6.215h3.545l2.86 6.253h.037c.23-.763 2.936-6.253 2.936-6.253zM74.24 23.424c0 .457.115.762.305.991.229.19.534.305.991.305h1.754v-7.739c0-.458-.114-.763-.305-.953-.19-.229-.534-.305-.953-.305h-1.754v7.7zM77.253 13.36c0 .304-.038.647-.153.914-.076.19-.228.381-.419.42-.305.076-.61.152-.915.152s-.648-.038-.915-.152c-.19-.077-.381-.23-.42-.42a2.6 2.6 0 0 1-.152-.915c0-.305.038-.648.153-.915.076-.19.228-.38.42-.42.304-.075.61-.152.914-.152s.648.039.915.153c.19.076.381.229.42.42.076.304.152.61.152.914'
            />
            <path
                fill='#0357EE'
                fillRule='evenodd'
                d='M98.717 20.03c0-1.41.495-2.553 1.448-3.392.954-.877 2.173-1.335 3.622-1.335s2.669.458 3.622 1.335c.991.877 1.487 2.02 1.487 3.393s-.496 2.516-1.487 3.393c-.953.877-2.173 1.296-3.622 1.296s-2.63-.42-3.622-1.296c-.99-.877-1.448-2.02-1.448-3.393m3.012 0c0 .649.19 1.183.571 1.564.382.381.877.61 1.449.61s1.068-.19 1.449-.61.61-.915.61-1.563-.191-1.182-.61-1.601a1.91 1.91 0 0 0-1.449-.648 1.91 1.91 0 0 0-1.449.648q-.571.629-.571 1.6M109.693 20.03c0-1.41.496-2.553 1.449-3.392.953-.877 2.173-1.335 3.622-1.335s2.668.458 3.621 1.335c.992.877 1.487 2.02 1.487 3.393s-.495 2.516-1.487 3.393c-.953.877-2.173 1.296-3.621 1.296-1.449 0-2.631-.42-3.622-1.296-.953-.877-1.449-2.02-1.449-3.393m3.05 0c0 .649.191 1.183.572 1.564s.877.61 1.487.61c.572 0 1.067-.19 1.449-.61.381-.42.61-.915.61-1.563s-.191-1.182-.61-1.601a1.91 1.91 0 0 0-1.449-.648c-.572 0-1.068.228-1.487.648q-.572.629-.572 1.6'
                clipRule='evenodd'
            />
            <path
                fill='#0357EE'
                d='M93.948 15.494c-1.373 0-2.173.8-2.364 1.03v2.63c.267-.8.915-1.182 1.601-1.182 1.03 0 1.716.877 1.716 2.173 0 1.373-.8 2.135-1.754 2.135-.8 0-1.334-.534-1.563-1.258v2.821c.343.381 1.03.877 2.25.877 2.287 0 4.04-1.83 4.04-4.651 0-2.669-1.6-4.575-3.926-4.575'
            />
            <path
                fill='#0357EE'
                d='M88.611 23.462c0 .457.115.8.305.991.23.19.534.305.992.305h1.753V13.36c0-.457-.114-.762-.305-.991-.19-.229-.533-.305-.953-.305H88.65v11.399zM120.713 23.462c0 .457.114.8.305.991.229.19.534.305.991.305h1.754V13.36c0-.457-.115-.762-.305-.991-.229-.19-.572-.305-.991-.305h-1.754z'
            />
            <path
                fill='#0357EE'
                d='M128.832 17.286q0 .457-.458.915l-1.868 1.868-2.135 2.135-2.135-2.135 4.918-4.918 1.22 1.22q.515.457.458.915'
            />
            <path
                fill='#0357EE'
                d='m129.48 23.004-1.22 1.22c-.305.305-.61.458-.915.496-.305 0-.61-.19-.915-.496l-4.194-4.193 2.135-2.135 2.135 2.135zM91.875 18.823v1.868a2.6 2.6 0 0 1-.152-.953c0-.344.038-.687.151-.915'
            />
        </svg>
    );
}

export function Fallback() {
    return (
        <main className='flex h-dvh w-full flex-col items-center justify-center gap-0 px-[28px] lg:gap-[90px]'>
            <div className='flex items-center px-5 py-10'>
                <Logo />
            </div>
            <div className='flex flex-col items-center gap-30'>
                <div>
                    <div className='flex w-full flex-col items-center gap-15 lg:w-275'>
                        <h2 className='text-center font-bold text-[22px] text-headless-darkest leading-[26.4px] lg:text-[26px] lg:leading-[32.6px]'>
                            Oops, something went wrong!
                        </h2>
                        <div className='flex flex-col gap-24 pt-20'>
                            <p className='text-center font-normal text-14 text-content-subtext-default leading-body tracking-typography-body'>
                                Looks like we hit a snag. Don't worry, our team
                                has been notified, and we're on it.
                            </p>
                            <p className='text-center font-normal text-14 text-content-subtext-default leading-body tracking-typography-body'>
                                Refresh the page to try again. Click the button
                                below to head back to the homepage.
                            </p>
                        </div>
                    </div>
                </div>
                <a
                    href='/dashboard/home'
                    className='flex h-40 cursor-pointer items-center justify-center whitespace-nowrap rounded-[8px] bg-primary px-16 font-semibold text-14 text-lightGrey leading-10'>
                    Go to Homepage
                </a>
            </div>
        </main>
    );
}
